export default __webpack_public_path__ + "static/media/maybach.14809651.jpeg";